<template>
  <div id="app" class="d-flex flex-column vh-100" data-spy="scroll">
    <div
      id="wrapper"
      :class="mostrarSideBar ? 'toggle dont-overflow'  : 'toggle dont-overflow toggled'"
    >
      <!--<Flecha />-->
      <Header @mostrarToggle="mostrarToggle" />
      <Section>
        <router-view @cargar="cargar" @cargado="cargado" @onError="atraparError"></router-view>
      </Section>
      <Footer />
      <Chatbot />
      <b-modal
        id="modalCargando-1"
        v-model="modalCargando"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
        hide-header
        size="sm"
      >
        <Cargando color="#000000" :tamanio="200" />
      </b-modal>
      <b-modal
        ref="modalError"
        v-model="modalError"
        centered
        no-close-on-esc
        ok-only
        hide-header
      >{{mensaje}}</b-modal>
      <Contactame :datosContacto="datosContacto" ref="modalContacto" />
      <ContactameTP :datosContacto="datosContacto" ref="modalContactoTP" />
      <SolicitarSimulacion ref="solicitarSimulacion" />
      <RespuestaEnvio ref="respuestaEnvio" :respuestaContacto="respuestaContacto" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/wrapper/Header";
import Footer from "@/components/wrapper/Footer";
import Cargando from "@/components/generales//modales/Cargando";
import Section from "@/components/wrapper/Section";
import Flecha from "@/components/generales/FlechaArriba";
import { EventBus } from "@/assets/js/EventBus";
import {
  MensajesDeCarga,
  MensajesDeError,
  ModalContacto,
  ModalContactoTP,
  ModalSolicitarSimulacion,
  MensajesDeRespuesta,
} from "@/utils/BusesDeEventos.js";
import Contactame from "@/components/generales/modales/Contactame";
import ContactameTP from "@/components/generales/modales/ContactameTP";
import SolicitarSimulacion from "@/components/generales/modales/SolicitarSimulacion";
import RespuestaEnvio from "@/components/generales/modales/RespuestaEnvio";
import Chatbot from "@/components/generales/Chatbot";
export default {
  name: "app",
  components: {
    Header,
    Footer,
    Cargando,
    Section,
    Flecha,
    Contactame,
    ContactameTP,
    SolicitarSimulacion,
    RespuestaEnvio,
    Chatbot,
  },
  data() {
    return {
      modalCargando: false,
      modalError: false,
      mostrarSideBar: false,
      mensaje: "",
      datosContacto: {},
      respuestaContacto: false,
    };
  },
  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function () {
      this.modalCargando = false;
    },
  },
  beforeCreate: async function () {
    MensajesDeCarga.$on("cargar", () => {
      this.cargar();
    });
    MensajesDeCarga.$on("cargado", () => {
      this.cargado();
    });
    MensajesDeError.$on("onError", (mensaje) => {
      this.atraparError(mensaje);
    });
    ModalContacto.$on("contactame", (datosContacto) => {
      this.datosContacto = datosContacto;
      this.mostrarContactame();
    });
    ModalContactoTP.$on("contactameTP", (datosContacto) => {
      this.datosContacto = datosContacto;
      this.mostrarContactameTP();
    });
    ModalSolicitarSimulacion.$on("solicitarSimulacion", () => {
      this.mostrarSolicitarSimulacion();
    });
    MensajesDeRespuesta.$on("respuestaEnvio", (respuestaContacto) => {
      this.respuestaContacto = respuestaContacto ? respuestaContacto : false;
      this.mostrarRespuestaEnvio();
    });
  },
  methods: {
    mostrarToggle(val) {
      this.mostrarSideBar = val;
    },
    handleScroll: function () {
      window.scrollY > 0
        ? (document.getElementById("myBtn").style.display = "block")(
            (document.getElementById("flecha-abajo").style.display = "none")
          )
        : (document.getElementById("myBtn").style.display = "none");
      document.getElementById("flecha-abajo").style.display = "none";
    },
    //atrapa error y muestra modal con informacion correspondiente
    atraparError(mensaje, titulo) {
      this.mensaje = mensaje;
      this.$refs["modalError"].show();
    },
    //muestra modal cargando
    cargar() {
      this.modalCargando = true;
    },
    //quita modal de cargando
    cargado() {
      this.modalCargando = false;
    },
    mostrarContactame() {
      this.$refs.modalContacto.showModal();
    },
    mostrarContactameTP() {
      this.$refs.modalContactoTP.showModal();
    },
    mostrarSolicitarSimulacion() {
      this.$refs.solicitarSimulacion.showModal();
    },
    mostrarRespuestaEnvio() {
      this.$refs.respuestaEnvio.showModal();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue